import { LiveLikeOption } from "@livelike/engagementsdk";
const html = (window as any).html;

class SBSTextPredictionOption extends LiveLikeOption {
  @((window as any).property({ type: Function }))
  setOptionSelected: (arg: {}) => void = () => {};
  createRenderRoot(): this {
    return this;
  }
  optionSelected = () => {
    if (!this.disabled) {
      this.parentElement
        .querySelectorAll("sbs-text-prediction-option")
        .forEach((el: any) => {
          el !== this && (el.selected = false);
        });
      this.selected = true;
      this.setOptionSelected(this.item);
    }
  };

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.optionSelected);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.optionSelected);
    super.disconnectedCallback();
  }

  render() {
    return html`
      <div class="livelike-voting-text-container">
        <livelike-description></livelike-description>
      </div>
    `;
  }
}
customElements.define(
  "sbs-text-prediction-option",
  SBSTextPredictionOption as any
);
